import axios from "./axios.tsx";
import type {
  SyncStatus,
  SyncIntegrationResponse,
  ApiResponse,
} from "../types";

/**
 * Trigger a manual sync for a specific integration.
 */
export function syncIntegration(
  integration_identifier: string,
): Promise<ApiResponse<SyncIntegrationResponse>> {
  return axios.post(
    "/v1/integrations/sync/",
    JSON.stringify({ integration_identifier }),
    { withCredentials: true },
  );
}

/**
 * Fetch the latest sync status for a specific integration.
 */
export async function fetchIntegrationSyncStatus(
  integration_identifier: string,
): Promise<SyncStatus | null> {
  const response = await axios.get<{ objects: SyncStatus[]; type: string }>(
    `/v1/integrations/sync_status/?integration=${integration_identifier}`,
  );
  return response.data.objects[0] || null;
}
